import { computed, ComputedRef } from 'vue';
import { usePage } from '@inertiajs/vue3';

export default function useRolesAndPermissions() {

  /**
   * Roles of the logged in User.
   */
  const roles: ComputedRef = computed(() => usePage().props.roles);

  /**
   * Permissions of the logged in User.
   */
  const permissions: ComputedRef = computed(() => usePage().props.permissions);

  /**
   * Determine if User has all the given roles.
   *
   * @param {Array<string>} givenRoles
   * @return Boolean
   */
  function hasRoles(givenRoles: Array<string>): boolean {
    for (let i = 0; i < givenRoles.length; i++) {
      if (roles.value.indexOf(givenRoles[i]) === -1) {
        return false;
      }
    }

    return true;
  }

  /**
   * Determine if the User has any of the roles.
   *
   * @param {Array<string>} givenRoles
   * @return Boolean
   */
  function hasAnyRole(givenRoles: Array<string>): boolean {
    for (let i = 0; i < givenRoles.length; i++) {
      if (roles.value.indexOf(givenRoles[i]) > -1) {
        return true;
      }
    }

    return false;
  }

  /**
   * Determine if the User has any of the permissions.
   *
   * @param {Array<string>} givenPermissions
   * @return Boolean
   */
  function hasAnyPermission(givenPermissions: Array<string>): boolean {
    if (hasAnyRole(['super admin'])) {
      return true;
    }

    for (let i = 0; i < givenPermissions.length; i++) {
      if (permissions.value.indexOf(givenPermissions[i]) > -1) {
        return true;
      }
    }

    return false;
  }

  return {
    roles,
    hasRoles,
    hasAnyRole,
    permissions,
    hasAnyPermission,
  };
}
